import React, {useRef, useEffect, useState} from 'react';
import {AppState, Platform, View, ActivityIndicator, StyleSheet, Text} from 'react-native';
import {useDispatch, useSelector} from "react-redux";
import {useQuickAuthentication} from '../hooks/useQuickAuthentication';
import {getCurrentRoute, navigate} from '../hooks/navigationService';
import {setDeepLinkPage} from "../reducers/pvtDeepLinkManager";

const FocusCheck = () => {
    const currentRoute = getCurrentRoute();
    const auth = useQuickAuthentication(hideSpinner);
    isAuthenticated = auth.isAuthenticated;
    authenticate = auth.authenticate;
    const [showSpinner, setShowSpinner] = useState(false);
    const appStateRef = useRef(AppState.currentState);
    const authStatus = useSelector((state) => state.cbcAuthorization.authLoading);
    const pageToNavigateTo = useSelector((state) => state.pvtDeepLinkManager.pageToNavigateTo);
    const dispatch = useDispatch();

    useEffect(() => {
        const handleAppStateChange = nextAppState => {
            const currentRoute = getCurrentRoute();
            if (appStateRef.current === 'background' && nextAppState === 'active') {
                if (!['login', 'loadScreen', null].includes(currentRoute) && Platform.OS !== 'web') {
                    console.log('Triggering authentication check');
                    setShowSpinner(true);
                    if (authStatus !== "pending") {
                        authenticate(hideSpinner);
                    }
                }
            }
            appStateRef.current = nextAppState;
        };

        const subscription = AppState.addEventListener('change', handleAppStateChange);

        return () => {
            subscription.remove();
        };
    }, []);

    useEffect(() => {
        const currentRoute = getCurrentRoute();
        if (authStatus === "pending" && !['login', 'loadScreen', null].includes(currentRoute)) {
            setShowSpinner(true);
        } else {
            setShowSpinner(false);
            checkForDeepLinkNav();
        }
    }, [authStatus]);

    if (!showSpinner) {
        return null;
    }

    function checkForDeepLinkNav() {
        if (pageToNavigateTo !== '' && !['login', 'loadScreen', null].includes(currentRoute)) {
            console.log('deeplink found,   to: ', pageToNavigateTo);
            navigate(pageToNavigateTo);
            dispatch(setDeepLinkPage(''));
        }
    }

    function hideSpinner(){
        setShowSpinner(false);
    }

    return (
        <View style={styles.container}>
            <ActivityIndicator size="large" color="#fff"/>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        backgroundColor: 'rgba(0,0,0,0.75)',
    },
});

export default FocusCheck;
